export enum DiscountPerCommitment {
  'oneMonth' = 0,
  'threeMonth' = 0.05,
  'oneYear' = 0.1,
}
